
import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
@Component({})
export default class LumpSumBudgetSheet extends Vue {
    @Prop({ default: () => [] })
    rows!: Array<any>;
    
    forceReload = 0;

    updateLineSum(activityId: any, departmentId: any, operationUnitId: any, lineValue: any) {
      this.$emit('lineValueChanged', {activityId, departmentId, operationUnitId, lineValue})
    }

    calculateTotal(rows: any[]) {
      return rows.reduce((acc, row) => acc + (row.lineValue || 0), 0);
    }

    get formattedData() {
      const budget = this.rows.map((item: any) => {
        const matchingLine = item.budgetLinesForThisMilestone.find((x: any) => String(x.departmentId).trim() === String(item.departmentId).trim()
            && String(x.operationUnitId).trim() === String(item.operationUnitId).trim()
            && String(x.activityId).trim() === String(item.activityId).trim());
        return {
          activityId: item.activityId,
          department: item.department,
          departmentId: item.departmentId,
          operationUnitId: item.operationUnitId,
          lineValue: matchingLine ? matchingLine.lineValue : item.lineValue || 0,
        }
      });

      return budget;
    }

    mounted() {
      this.forceReload += 1;
    }
}
